// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".width-100{width:100%}.font-700{font-weight:700}.font-16{font-size:16px;line-height:150%}.font-22{font-size:22px;line-height:150%}.has-text-black{color:#000}.has-text-primary{color:#f69e1e}.has-text-grey{color:#222}.has-text-strikethrough{text-decoration:line-through}.line-height-21{line-height:21px!important}", ""]);
// Exports
module.exports = exports;
